import React, { memo } from 'react';
import * as styles from './styles';
import { useIframe } from './useIframe';
import { useLoadYoutubeIframeApi } from './useloadYoutubeIframeApi';
import { useThumbnail } from './useThumbnail';

export interface YoutubeProps {
  videoId: string;
  onStart?: () => void;
}

function Youtube({ videoId, onStart }: YoutubeProps) {
  const { rootRef, thumbnail, played } = useThumbnail(videoId, onStart);
  const apiFulfilled = useLoadYoutubeIframeApi();
  const iframeEl = useIframe(videoId, played, apiFulfilled);

  return (
    <div ref={rootRef} className={styles.youtube} aria-label="youtube video">
      {thumbnail}
      {iframeEl}
    </div>
  );
}

export default memo(
  Youtube,
  (prev, next) => prev.videoId === next.videoId && prev.onStart === next.onStart
);
